export const STRINGS = {
  MODE: {
    CREATE: "C",
    EDIT: "E",
  },
  DEFAULT_LIMIT: 25,
  DEFAULT_OFFSET: 0,
  DEFAULT_STATUS: "PENDING",
};
